import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory, Link, withRouter } from 'react-router';
import ShowOptions from '../components/options/ShowOptions';
import { clearAuthErrors, fetchOptions, disableOption, clearOptionsErrors } from '../actions';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import RaisedButton from 'material-ui/RaisedButton';
import Pagination from '../components/home/Pagination';
import TextField from 'material-ui/TextField';
import { cyan900 } from 'material-ui/styles/colors';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  options: PropTypes.object.isRequired,
  query: PropTypes.object.isRequired,
  router: PropTypes.object,
};

class OptionsPage extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  // TODO: review this, why duplication on each Container - gabo
  getChildContext() {
    return {
      muiTheme: getMuiTheme(baseTheme),
    };
  }
  componentWillMount() {
    this.props.dispatch(clearOptionsErrors());
    if (!this.props.isAuthenticated) {
      this.props.dispatch(clearAuthErrors());
      browserHistory.goBack();
    }
    const query = this.props.query;
    const router = this.props.router;
    if (this.props.options.search && this.props.options.search.length > 0) {
      query.search = this.props.options.search;
    }
    if (!query.page) {
      query.page = 1;
      router.push({ pathname: '/options', query });
    } else {
      this.props.dispatch(fetchOptions(query));
    }
  }
  onOptionDisable(data) {
    this.props.dispatch(disableOption(data));
  }
  handleSearchChange(e) {
    const options = this.props.options;
    const query = this.props.query;
    const router = this.props.router;
    const nextName = e.target.value;
    options.search = nextName;
    this.setState({
      options,
    });
    if (nextName.length > 0) {
      query.search = nextName;
    } else {
      delete query.search;
    }
    query.page = 1;
    router.push({ pathname: '/options', query });
    this.props.dispatch(fetchOptions(query));
  }
  navigation(route) {
    // add search to url
    this.props.dispatch(fetchOptions(route));
  }
  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '1%',
      },
    };
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="option component" style={authPage}>
        <h2>Options</h2>
        <div className="content">
          <div className="action-buttons">
            <Link to="/options/new">
              <RaisedButton
                label="Add New Option"
                primary
              />
            </Link>
          </div>
          <div className="action-buttons top">
            <TextField
              floatingLabelText="Search by Name"
              floatingLabelStyle={styles.floatingLabelStyle}
              inputStyle={styles.inputStyle}
              value={this.props.options.search}
              onChange={this.handleSearchChange}
            />
            <Pagination
              paginationInfo={this.props.options.meta}
              pageCall={route => this.navigation(route)}
            />
          </div>
          <hr />
          <ShowOptions
            options={this.props.options}
            onOptionDisable={data => this.onOptionDisable(data)}
          />
        </div>
        <div className="action-buttons bottom">
          <Pagination
            paginationInfo={this.props.options.meta}
            pageCall={route => this.navigation(route)}
          />
        </div>
      </div>
    );
  }
}

OptionsPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

OptionsPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    options: state.options,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(OptionsPage));



// WEBPACK FOOTER //
// ./src/containers/OptionsPage.js